import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { BoxDiv } from './box';

import cart from '../assets/icon/gwc_jdyf_icon@3x.png';

import { HighLightedButton } from './button';

const Container = styled(BoxDiv)`
  position: relative;
`;

const MockImageWrapper = styled.div`
  padding: 52px 80px 40px 80px;
  img {
    max-width: 100%;
  }
`;

const DescriptionWrapper = styled(MockImageWrapper)`
  padding: 0 80px 40px;
`;

const ShoppingButton = styled(HighLightedButton)`
  background-color: #f54746;
  width: 215px;
  position: absolute;
  top: 50px;
  right: 80px;
  
  img {
    display: inline-block;
    margin-top: -3px;
    margin-left: 16px;
    margin-right: 5px;
    max-height: 28px;
  }
  & > * {
    vertical-align: middle;
  }
`;

class ClassicScript extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    window.open(
      this.props.to,
      '_blank'
    );
  }

  render() {
    const { buttonText } = this.props;
    return (
      <Container>
        <MockImageWrapper>
          <img src={this.props.top} alt='top-mock' />
        </MockImageWrapper>
        <ShoppingButton onClick={this.onClick}>
          {buttonText}<img src={cart} alt='cart' />
        </ShoppingButton>
        <DescriptionWrapper>
          <img src={this.props.bottom} alt='bottom-mock' />
        </DescriptionWrapper>
      </Container>
    );
  }
}

ClassicScript.propTypes = {
  top: PropTypes.any.isRequired,
  bottom: PropTypes.any.isRequired,
  to: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};
ClassicScript.defaultProps = {};

export default ClassicScript;



// WEBPACK FOOTER //
// ./src/components/classic-script.jsx